export default "__VITE_ASSET__kXcM_mCF__"